import api from '../services/api';
import { $Q, $Qll } from '../utils/query-selector';
import { stringToHTML } from '../utils/to-html';
import { dataToggle } from '../utils/toggle-dataset';

/**
 * @param {Number} variant id selected
 * @param {HTMLElement} variant it is the HTML modal cart
 */
export async function fetchMainProduct(variant, modalCart, isBundle) {
  const modalCart1 = $Q('.modal-cart');
  const product_detail = modalCart
    ? $Q('#main-product__detail', modalCart1)
    : $Q('#main-product__detail');


  if (!product_detail) return;

  const product_url =  product_detail.dataset.url;
  const params = {
    variant,
    sections: 'ajax-main-product,sticky-cart',
  }; 

  const response = await api.shopifySectionByUrlAndParams(product_url, params);
  const sectionHTML = stringToHTML(response['ajax-main-product']);
  const stickyHTML = stringToHTML(response['sticky-cart']);

  updateSectionData(sectionHTML, stickyHTML, isBundle);
}

/**
 * @param {Document} body converted with DOM parser
 */
function updateSectionData(body, stickyHTMLbody, isBundle) {
  const modalCart = $Q('.modal-cart');

  updateCheckoutbutton(body, modalCart);
 // const radioSubscription = $Q(`[name="subscriptions"]:checked`, body);
  const pricesToEvaluate = [
    '.compare',
    '.selling-plan-compare',
    '.main-product__subscriptions-discount',
  ];

  const elemsToRender = [
    '.main-product__subscriptions-discount-price',
    '.jc-main-product-price',
    '.jc-main-product__subscriptions-price',
    '.jc-main-product-subscriptions-price',
    '.jc-special-label',
    '.jc-main-product-stock',
    '.jc-main-product-b2b-limit',
    '.variant-quantity',
  ];

  const elemsSticky = [
    '.jc-sticky-image',
    '.jc-main-product-sticky-price',
    '.jc-main-product-sticky-subscriptions-price',
    '.jc-buy-btn-price',
    '.jc-buy-btn-subscription-price'
  ];

  pricesToEvaluate.forEach((query) => {
    if ($Q(query)) {
      updatePrice(body, query, modalCart);
    }
  });

  elemsToRender.forEach((query) => {
    if ($Q(query)) {
      updateItem(body, query, modalCart);
    }
  });

  elemsSticky.forEach((query) => {
    if ($Q(query)) {
      updateStickyPopup(stickyHTMLbody, query, modalCart);
    }
  });

  if (isBundle == false) {
    updateBundlesOptions(body);
  }
}

const updateBundlesOptions = (body) => {
  const modalCart = $Q(`.modal-cart`);
  let bundleOptions = $Qll(`.bundle_option`);

  if (modalCart && modalCart.dataset.active == 'true') {
    bundleOptions = $Qll(`.modal-cart .bundle_option`);
  }


  const fetchedBundleOptions = $Qll('.bundle_option', body);

  if (!bundleOptions && !fetchedBundleOptions) return;


  bundleOptions.forEach((option, index) => {
    option.innerHTML = fetchedBundleOptions[index].innerHTML;
  });
};

const updateStickyPopup = (body, query, modalCart) => {
  const modalActive = modalCart?.dataset && modalCart?.dataset.active;
  const renderElementsFetched = $Qll(`.sticky-cart ${query}`, body);
  const renderElementsDOM = $Qll(`.sticky-cart ${query}`);

  if (!renderElementsDOM) return;
  if (modalActive === 'true') return;

  renderElementsDOM.forEach((element) => {
    element.classList.add('jc-hidden');
  }); 

  if (!renderElementsFetched) return;

  renderElementsFetched.forEach((element, index) => {
    const innerHTML = element.outerHTML;
    renderElementsDOM[index].outerHTML = innerHTML;
    element.classList.remove('jc-hidden');
  });
};

/**
 * This function updates items in main product, modal cart and sticky cart
 * @param {HTMLElement} body - This is the fetched section
 * @param {String} query - This is the query for render element
 * @param {HTMLElement} modalCart - It is the modal cart element
 * @returns
 */
const updateItem = (body, query, modalCart) => {
  const modalActive = modalCart?.dataset && modalCart?.dataset.active;
  const renderElementsFetched = $Qll(`.main-product__detail ${query}`, body);
  const renderElementsDOM =
    modalActive === 'true'
      ? $Qll(`.main-product__detail ${query}`, modalCart)
      : $Qll(`.main-product__detail ${query}`);

  if (!renderElementsFetched) return;

  renderElementsFetched.forEach((element, index) => {
    const innerHTML = element.outerHTML;
    if (innerHTML && renderElementsDOM[index]) {
      renderElementsDOM[index].outerHTML = innerHTML;
    }
  });
};

/**
 * This function updates the regular and compare prices in main product, modal cart and sticky cart
 * @param {HTMLElement} body - This is the fetched section
 * @param {String} query - This is the query for regular or compare price
 * @param {HTMLElement} modalCart - It is the modal cart element
 * @returns
 */
const updatePrice = (body, query, modalCart) => {
  const modalActive = modalCart.dataset && modalCart.dataset.active;
  const pricesElementsFetched = $Qll(`.main-product__detail ${query}`, body);

  const pricesElementsDOM =
    modalActive === 'true'
      ? $Qll(`.main-product__detail ${query}`, modalCart)
      : $Qll(`.main-product__detail ${query}`);


  pricesElementsFetched.forEach((element, index) => {
    const price = element.innerText.trim();
    pricesElementsDOM[index].innerText = price;

    let priveVal = price.replace('%', '').replaceAll(' ','').replaceAll('<br>','');
    pricesElementsDOM[index].setAttribute('data-price-val', priveVal)
  });
};
 

/**
 * This updates the button depending on its inventory quantity and policy,
 * taking the response from section rendering api
 * @param {Document} body converted with DOM parser
 */
function updateCheckoutbutton(body, modalCart) {
  let isModalOpened = modalCart.dataset.active;
  let ATCbutton = $Q('.btn-add-to-cart');
  if (isModalOpened == 'true') { 
    ATCbutton = $Q('.btn-add-to-cart', modalCart);
  }

  const fetchedButton = $Q('.btn-add-to-cart', body);
  const stickyBtn = $Q('.sticky-btn-add-to-cart');
  const quantityBtn = $Q('.jc-main-product-quantity');
  const fetchedQuantityBtn = $Q('.jc-main-product-quantity', body);
  const klaviyoOffStock = $Qll('.btn-of-stock');

  if (!ATCbutton || !fetchedButton) return;

  const quantity =
    typeof fetchedButton.dataset.quantity === 'string' &&
    parseInt(fetchedButton.dataset.quantity);

  const policy = fetchedButton.dataset.policy;
  const disableButton = quantity <= 0 && policy === 'deny';

  klaviyoOffStock.forEach((klaviyoBtn) => {
    disableButton
      ? (klaviyoBtn.style.display = 'block')
      : (klaviyoBtn.style.display = 'none');
  });

  if (stickyBtn && isModalOpened == 'false') {
    stickyBtn.disabled = fetchedButton.disabled;
    stickyBtn.innerHTML = fetchedButton.innerHTML;
  }

  if (quantityBtn) {
    quantityBtn.setAttribute('data-active', fetchedQuantityBtn.getAttribute('data-active'));
  }

  ATCbutton.disabled = fetchedButton.disabled;
  ATCbutton.innerHTML = fetchedButton.innerHTML;
  ATCbutton.dataset.quantity = quantity;
  ATCbutton.dataset.policy = policy;

  disableButton
    ? ATCbutton.classList.add('btn-of-stock', 'klaviyo-bis-trigger')
    : ATCbutton.classList.remove('btn-of-stock', 'klaviyo-bis-trigger');
}

/**
 * It toggle between suscription options
 * @param {String} query - It is the query to read subscription options
 * @param {String} from - Reads if it comes from sticky select
 * @param {Boolean} from - It reads if it belongs to modal cart
 */
export function toggleSubscriptionOptions(query, from, isFromModal) {
  const wrappers = $Qll(query);

  wrappers.forEach((element, index) => {
    let config = { element, index, wrappers, clicked: true };

    element.addEventListener('click', function (ev) {
      const shouldForceUpdateSticky = ev.target.classList.contains(
        'main-product__subscriptions-row'
      );

      toggleSubscriptionOptionProperties(
        config,
        isFromModal,
        shouldForceUpdateSticky
      );
    });

    from && setSubscriptionConfig(config, from, index);
  });
}

/**
 * It set the subscription configuration and executes the toggle for properties
 * @param {Object} config - It has configuration data to toggle properties
 * @param {String} from - It indicates the type of purchase
 * @param {number} index - It indicates the index in the for loop
 */
const setSubscriptionConfig = (config = {}, from, index) => {
  const purchaseOptions = {
    single: { id: 0, body: { ...config, index: 0 } },
    subscription: { id: 1, body: { ...config, index: 1, clicked: false } },
  };

  index === purchaseOptions[from]['id'] &&
    toggleSubscriptionOptionProperties(purchaseOptions[from]['body']);
};

/**
 * Toggle subscription properties from main product and stickt cart
 * @param {Object} config - is a list of nodes with length equal to 2
 * @param {NodeList} config.element - is a list of nodes with length equal to 2
 * @param {Number} config.index - is the iterator in the NodeList
 * @param {Document} config.wrappers - is the current document from the NodeList
 * @param {Boolean} config.clicked - if is clicked in main product select
 * @param {Boolean} isFromModal - It reads if it belongs to modal cart
 * @returns
 */
function toggleSubscriptionOptionProperties(
  config,
  isFromModal,
  shouldForceUpdateSticky
) {
  const { element, index, wrappers, clicked } = config;
  const subscriptionRadioBtns = $Qll(
    `${isFromModal ? '.modal-cart' : ''} .main-product__subscriptions-check`
  );
  const active = element.dataset.active === 'true' ? true : false;

  // !isFromModal &&  syncSubscriptionOptions(index, clicked, shouldForceUpdateSticky);

  if (active) return;

  const sellingPlanSelect = $Qll('.selling-plans', element[index])[1];


  const elements = {
    wrappers,
    subscriptionRadioBtns,
    isFromModal,
  };

  toggleRadioBtn(index, true, { ...elements });
  toggleRadioBtn(index === 0 ? 1 : 0, false, {
    ...elements,
    sellingPlanSelect,
  });

  //  syncStickyPrice();
}

/**
 * @param {Number} index is the iterator to identify
 * @param {Boolean} check enable or disable radio btn
 * @param {Object} elements which contains wrappers, subscriptionRadioBtns
 *                 and isFromModal
 */
function toggleRadioBtn(index, check, elements) {

  const { wrappers, subscriptionRadioBtns, isFromModal } = elements;
  dataToggle(wrappers[index]);
  subscriptionRadioBtns[index].checked = check;

  const radioBtns = $Qll(
    `${isFromModal ? '.modal-cart' : ''} .main-product__subscriptions-radio`
  );

  let variantObject = '';

  if (!radioBtns) return;

  radioBtns.forEach((btn, i) => {
    if (index !== i) return;

    btn.classList.add('main-product__subscriptions-radio--checked');
    setTimeout(() => {
      btn.classList.remove('main-product__subscriptions-radio--checked');
    }, 500);
  });

  const inputs = $Qll(`${isFromModal ? '.modal-cart' : '.main-product__subscriptions-form'} [name="id"]`);

  const radio = $Q(
    `${isFromModal ? '.modal-cart' : ''} [name="subscriptions"]:checked`
  );

  const firstBundlesInput = $Qll(
    `${isFromModal ? '.modal-cart' : ''} .js-variant-radio`
  );

  const mainProductPriceContainer = $Qll(
    `${isFromModal ? '.modal-cart' : ''} .jc-price-container`
  );

  let currentOption = $Q(
    `${isFromModal ? '.modal-cart #main-product__detail' : '#main-product__detail'} .jc-variant-option.active`
  );

  let option2 = $Q(
    `${isFromModal ? '.modal-cart' : ''} .js-variant-radio:checked`
  ) ? $Q(`${isFromModal ? '.modal-cart' : ''} .js-variant-radio:checked`).value : '';

  let zeroItem = $Q(`${isFromModal ? '.modal-cart' : ''} .js-variant-radio[value="Abonnement"]`);

  if (radio.value == 'subscribe') {
    if (zeroItem) {
      option2 = 'Abonnement';
      firstBundlesInput[1].checked = true;
    } else {
      option2 = $Q(
        `${isFromModal ? '.modal-cart' : ''} .js-variant-radio:checked`
      ) ? $Q(`${isFromModal ? '.modal-cart' : ''} .js-variant-radio:checked`).value : '';

      if (firstBundlesInput.length > 0 && firstBundlesInput[0]) {
        firstBundlesInput[0].checked = true;
      }
    }

    if (mainProductPriceContainer) {
      mainProductPriceContainer.forEach((item) => {
        item.setAttribute('data-active', true);
      });
    }
  } else {
    if (zeroItem) {
      option2 = 'x1'
      if (firstBundlesInput.length > 0 && firstBundlesInput[0]) {
        firstBundlesInput[1].checked = true;
      }
    } else {
      // option2 = $Q(`${isFromModal ? '.modal-cart' : ''} .js-variant-radio:checked`).value;
      if (firstBundlesInput.length > 0 && firstBundlesInput[0]) {
        firstBundlesInput[0].checked = true;
      }
    }

    if (mainProductPriceContainer) {
      mainProductPriceContainer.forEach((item) => {
        item.setAttribute('data-active', false);
      });
    }
  }

  let variants = JSON.parse(
    $Q(`${isFromModal ? '.modal-cart' : ''} #variants`).value
  );

  function findProductId(option1, option2) {
    const variant = variants.find(
      (p) => p.option1 === option1 && p.option2 === option2
    );
    return variant ? variant : null;
  }

  const option1 = currentOption.dataset.option;


  let variant_id = '';

  if (option2) {
    variantObject = findProductId(option1, option2);
    variant_id = variantObject.id;
  } else {
    variant_id = currentOption.dataset.variant
  }

  fetchMainProduct(variant_id, isFromModal, false);

  if (inputs.length > 0) {
    inputs.forEach((item) => {
      item.value = variant_id;
    });
  }
}


export function toggleSubscriptionInfo(query = '') {
  const subscriptionInfos = $Qll(`${query}.main-product__subscriptions-info`);

  if (!subscriptionInfos) return;

  subscriptionInfos.forEach((subscriptionInfo) => {
    subscriptionInfo.addEventListener('mouseenter', () => {
      if (subscriptionInfo.dataset.active === 'false') {
        dataToggle(subscriptionInfo);
      }

    });
  });

  subscriptionInfos.forEach((subscriptionInfo) => {
    subscriptionInfo.addEventListener('mouseleave', () => {
      if (subscriptionInfo.dataset.active === 'true') {
        dataToggle(subscriptionInfo);
      }
    });
  });
}
